import dayjs from 'dayjs'
const UA = window.navigator.userAgent
const LocationSearch = window.location.search

// 当前是否是 微信
export const IsWeChat = /MicroMessenger/i.test(UA)

//当前是否是  链上会应用 (包含桌面端)
export const IsChainPal = /ChainMeet/i.test(UA) || /ChainPal/i.test(UA)

// 当前是否是 桌面端 链上会应用 (仅桌面端)
export const IsChainPalForPc = /ChainPalForPc/i.test(UA)

// 当前是 wx|app|m|ipad|pc
export const UAPlatform = (() => {
  let isSafari = UA.indexOf('Safari') !== -1 && UA.indexOf('Version') !== -1
  let isIphone = UA.indexOf('iPhone') !== -1 && UA.indexOf('Version') !== -1
  if (/ChainMeet/i.test(UA) || /ChainPal/i.test(UA)) {
    return 'app'
  } else if (/MicroMessenger/i.test(UA)) {
    return 'wx'
  } else if (
    /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(
      UA
    )
  ) {
    return 'm'
  } else if (isSafari && !isIphone && 'ontouchend' in document) {
    return 'ipad'
  } else {
    return 'pc'
  }
})()

// 当前是 Android | Ios
export const UASystem = (() => {
  let isAndroid = UA.indexOf('Android') > -1 || UA.indexOf('Linux') > -1
  let isIOS = !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  if (isAndroid) {
    return 'android'
  }
  if (isIOS) {
    return 'ios'
  }
  return ''
})()

/**
 * @desc 获取路径参数
 * @params [String]
 * @return  host
 */
export const getQueryValue = (queryName) => {
  let query = decodeURI(LocationSearch.substring(1))
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] === queryName) {
      return pair[1]
    }
  }
  return null
}

// 正则验证
const testPlatform = (arr) => {
  let lowerUa = UA.toLowerCase() || 'default'
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].test(lowerUa)) {
      return true
    }
  }
  return false
}
/**
 * @desc 判断当前设备机型
 */
const judgeBrand = () => {
  // huaiwei,Honor
  let isHuawei = testPlatform([/huawei/i, /honor/i])
  // oppo,OppoR15,OppoR4,OppoA5,OppoR152,OppoA9,OppoR,OppoFx,OppoR17
  let isOppo = testPlatform([
    /oppo/i,
    /pacm00/i,
    /pdpt00/i,
    /pbam00/i,
    /pact00/i,
    /pcam10/i,
    /pcam00/i,
    /pafm00/i,
    /pbet00/i
  ])
  //vivo,VivoZ3,VivoZ5x,VivoX27
  let isVivo = testPlatform([/vivo/i, /v1813bt/i, /v1911a/i, /v1838a/i])
  //xiaomi ,Redmi,Xiaomi2s
  let isXiaomi = testPlatform([/mi\s/i, /mix\s/i, /redmi/i])
  return isHuawei
    ? 'huawei'
    : isOppo
    ? 'oppo'
    : isVivo
    ? 'vivo'
    : isXiaomi
    ? 'xiaomi'
    : 'default'
}

/**
 * @return 获取 下载app 的各个市场对应的 url
 */
export const downloadAppUrl = (() => {
  // 安卓系统
  if (/Android/i.test(UA)) {
    let brand = judgeBrand()
    return brand === 'huawei'
      ? 'https://appgallery.huawei.com/#/app/C104473553'
      : ['oppo', 'vivo'].includes(brand)
      ? 'market://details?id=com.tongfudun.dtcmessenger'
      : 'https://dappstore.tongfudun.com/#/appList/detail/f1d7001bef21996f' // default类型，通过D市场下载
  }
  // ios  市场
  return 'https://apps.apple.com/cn/app/%E9%93%BE%E4%B8%8A%E4%BC%9A-%E6%97%97%E8%88%B0%E7%89%88/id1635723004'
})()

/**
 * @desc html 进行转码
 * @param {String} str
 */
export const htmlEncode = (str) => {
  let s = ''
  if (!str.length) return ''
  s = str.replace(/&/g, '&amp;')
  s = s.replace(/</g, '&lt;')
  s = s.replace(/>/g, '&gt;')
  s = s.replace(/ /g, '&nbsp;')
  s = s.replace(/'/g, '&#39;')
  s = s.replace(/"/g, '&quot;')
  return s
}
/**
 * @desc 是否安装app 并唤起打开app
 */
export const openApp = (url, callBack) => {
  // 添加href 跳转
  window.location.href = url
  let initialTime = new Date()
  let counter = 0
  let waitTime = 0
  let checkOpen = setInterval(() => {
    counter++
    waitTime = new Date() - initialTime
    if (waitTime > 1000) {
      callBack && callBack(true)
      clearInterval(checkOpen)
    }
    if (counter < 1000) {
      return
    }
    let hide = document.hidden || document.webkitHidden
    if (!hide) {
      // 唤端失败的回调函数
      callBack && callBack(true)
    }
  }, 20)

  document.addEventListener('visibilitychange', () => {
    let isHidden = document.hidden
    if (isHidden) {
      callBack && callBack(false)
      clearInterval(checkOpen)
    }
  })
}
/**
 * @desc 时间计算
 */
export const dateDifference = (start, end, lang) => {
  let usedTime = dayjs(end) - dayjs(start) //两个时间戳相差的毫秒数
  //计算出小时数
  let leave1 = usedTime % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000))
  //计算相差分钟数
  let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000))
  let mins = lang === 'zh' ? '分钟' : 'mins'
  let hrs = lang === 'zh' ? '小时' : 'hrs'
  return hours && minutes
    ? `${hours}${hrs} ${minutes}${mins}`
    : hours
    ? `${hours}${hrs}`
    : minutes
    ? `${minutes}${mins}`
    : ''
}

/**
 * @desc 手机号脱敏
 */
export const resetTel = (tel) => {
  if (/^1[3|4|5|7|8|9][0-9]{9}$/.test(tel)) {
    return tel.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
  }
  return tel
}

/**
 * @desc 单位换算
 */
export const mixinTransfromByte = (limit, unit) => {
  limit = Number(limit)
  let size = ''
  // 1 * 1024 * 1024 = 1048576; 1MB
  // 1 * 1024 * 1024 * 1024 =  1073741824 ;  1GB
  // 1 * 1024 * 1024 * 1024 * 1024 =  1099511627776 ;  1TB
  if (limit < 1024) {
    //小于1KB，则转化成B
    // size = limit.toFixed(2) + "B";
    size = Math.round(limit * 100) / 100 + 'B'
  } else if (limit < 1048576) {
    //小于1MB，则转化成KB
    // size = (limit / 1024).toFixed(2) + "KB";
    size = Math.round((limit / 1024) * 100) / 100 + 'KB'
  } else if (limit < 1073741824) {
    //小于1GB，则转化成MB
    // size = (limit / 1048576).toFixed(2) + "MB";
    size = Math.round((limit / 1048576) * 100) / 100 + 'MB'
  } else if (limit < 1099511627776 || unit === 'GB') {
    //其他转化成GB
    // size = (limit / 1073741824).toFixed(2) + "GB";
    size = Math.round((limit / 1073741824) * 100) / 100 + 'GB'
  } else {
    size = Math.round((limit / 1099511627776) * 100) / 100 + 'TB'
  }

  let sizeStr = size + '' //转成字符串
  let index = sizeStr.indexOf('.') //获取小数点处的索引
  let dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
  if (dou === '00') {
    //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
  }
  return sizeStr
}
/**
 * @desc 获取浏览器语言环境
 */
export const navigatorLanguage = (() => {
  if (IsChainPal) {
    return UA.indexOf('en-US') > -1 ? 'en' : 'zh'
  }
  if (IsWeChat) {
    return UA.indexOf('Language/en') > -1 ? 'en' : 'zh'
  }
  return navigator.language.indexOf('zh') > -1 ? 'zh' : 'en'
})()
